export interface Shift {
    id?: number;
    shiftNo: string;
    branchId?: number;
    shiftStatus: ShiftStatus;
    startTime: string;
    endTime: string;
    categoryId?: number;
}


export enum ShiftStatus {
    ShiftsOpen = 'ShiftsOpen',
    ShiftsClose = 'ShiftsClose',
    ShiftsStage = 'ShiftsStage',
}

export const ShiftStatusTranslations: Record<ShiftStatus, string> = {
    [ShiftStatus.ShiftsOpen]: 'مفتوحة',
    [ShiftStatus.ShiftsClose]: 'مغلقة',
    [ShiftStatus.ShiftsStage]: 'قيد التجهيز',
};
